// components/BecomePartner.js
import React from "react";
import "./BecomePartner.css";

export default function BecomePartner() {
  return (
    <section className="partner-banner">
      <div className="partner-container">
        <h2 className="partner-title">Become a Partner</h2>
        <p className="partner-text">
          The <strong>iSpeakWell Project</strong> is growing — and we’re looking for
          creative collaborators, institutions, and sponsors who share our vision of
          making English fluency measurable, inclusive, and empowering.  
          <br />
          Whether you’re an educator, developer, investor, or advocate for learning
          innovation, we’d love to hear from you.
        </p>

        <div className="partner-buttons">
          <a
            href="mailto:steve.kurowski@gmail.com?subject=Partner Inquiry – The iSpeakWell Project"
            className="partner-btn"
          >
            Email Steven
          </a>
          <a
            href="/contactus"
            className="partner-btn secondary"
          >
            Contact Form
          </a>
        </div>
        <p className="partner-footer">
          Together, we can give every learner a voice.
        </p>
      </div>
    </section>
  );
}
